﻿import { faFileExcel } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Backdrop, Button, CircularProgress, Tooltip } from "@mui/material";
import React from "react";

interface IExportButtonProps {
    link: string;
    disabled?: boolean;
    children?:  React.ReactNode;
}

const ExportButton: React.FC<IExportButtonProps> = ({link, disabled, children}) => {
    return (
        <Tooltip
            title="Must select a session"
            disableHoverListener={!disabled}
        >
            <span>
                <Button
                    href={link}
                    variant="outlined"
                    disabled={disabled}
                    sx={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'space-between',
                        px: 2
                    }}
                >
                    {children} <FontAwesomeIcon icon={faFileExcel} size="2x" />
                </Button>
            </span>
        </Tooltip>
        
    );
}

export default ExportButton;